export default __webpack_public_path__ + "static/media/balance-card-bg-new.560a9d75.svg";